import React, { useEffect } from "react";

export const DownloadPage = () => {
  useEffect(() => {
    const userAgent = navigator.userAgent || navigator.vendor;

    if (/iPhone|iPad|iPod/.test(userAgent)) {
      window.location.href = "https://apps.apple.com/kh/app/l192-delivery-and-business/id1456557205";
    } else {
      window.location.href = "https://play.google.com/store/apps/details?id=com.l192business.app&hl=en";
    }
  }, []);

  return (
    <div>
      <h1>Redirecting to the app store...</h1>
    </div>
  );
};

export default DownloadPage;
